import { NgModule } from '@angular/core';
import { LayoutComponent } from './components/layout/layout.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSliderModule } from '@angular/material/slider';
import { MatMenuModule } from '@angular/material/menu';


import { CompartidoModule } from '../@compartido/compartido.module';
import { RouterModule } from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorIntlMex } from './components/paginacion/textos-mat-paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { BlockTemplateComponent } from './components/block-iu-template/block-iu-template.component';
import { InputPeriodoComponent } from './components/input-periodo/input-periodo.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatRadioModule} from '@angular/material/radio';
import { ModalGenericoComponent } from './components/modal-generico/modal-generico.component';
import { InputStarComponent } from './components/input-star/input-star.component';
import { MatChipsModule} from '@angular/material/chips';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ConfirmarAccionComponent } from './components/confirmar-accion/confirmar-accion.component';
import { CommonModule } from '@angular/common';
import { TablaMaterialComponent } from './components/tabla-material/tabla-material.component';
import { PaginacionV2Component } from './paginacion-v2/paginacion-v2.component';



const MAT_MODULES = [

  LayoutModule,
  MatToolbarModule,
  MatButtonModule,
  MatSidenavModule,
  MatIconModule,
  MatListModule,
  MatNativeDateModule,
  MatRippleModule,
  MatListModule,
  MatInputModule,
  MatExpansionModule,
  // MatListModule,
  // MatButtonModule,
  MatCheckboxModule,
  MatButtonToggleModule,
  MatSnackBarModule,
  MatCardModule,
  MatSliderModule,
  MatDialogModule,
  MatSelectModule,
  MatMenuModule,
  MatDatepickerModule,
  MatTooltipModule,
  // MatMomentDateModule,
  MatRadioModule,
  // MatAutocompleteModule,
  MatSlideToggleModule,
  MatDividerModule,
  // MatGridListModule,
  MatStepperModule,
  MatTabsModule,
  // MatTreeModule,
  // MatBadgeModule,
  MatChipsModule,
  MatProgressSpinnerModule,
  MatProgressSpinnerModule,
  // MatBottomSheetModule,
  MatPaginatorModule,
  MatSortModule,
  MatTableModule,
  MatPaginatorModule,
  DragDropModule,
  ScrollingModule,
];

const MAT_PROVIDERS = [
  // { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: CONFIG_MODALS },
  { provide: MatPaginatorIntl, useClass: MatPaginatorIntlMex },
];

const COMPONENTS = [ 
  LayoutComponent,
  BlockTemplateComponent,
  InputPeriodoComponent, 
  ModalGenericoComponent, 
  InputStarComponent, 
  ConfirmarAccionComponent,
  TablaMaterialComponent,
  PaginacionV2Component
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [ ...MAT_MODULES, CompartidoModule, RouterModule],
  exports: [...MAT_MODULES, ...COMPONENTS],
  providers: [ ...MAT_PROVIDERS ]
})
export class TemaModule { 
}
